import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { ObjectReturnModeEnum } from '../../enum/object-return-mode.enum';
import { IAirportLight } from '../../model/airport-light.model';
import { IAirport } from '../../model/airport.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class AirportService {
  async getAirports(): Promise<IAirport[]> {
    return CaiApi.get(API_CORE.name, API_CORE.URLs.Airport.Airports, {});
  }

  async getAirportsLight(): Promise<IAirportLight[]> {
    const extraOptions: any = {
      queryParams: {
        mode: ObjectReturnModeEnum.LIGHT,
      },
    };
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Airport.Airports,
      extraOptions,
    );
  }
}
